import React from 'react';
import styled from 'styled-components';
import { Rocket, MoneyBall } from 'src/assets/images';
import { useNavigate } from 'react-router-dom';

const UserTypeSection: React.FC = () => {
  const navigate = useNavigate();
  const handleInternalRedirect = () => {
    navigate('/sign-up');
  };

  const signupRedirect = () => {
    navigate('/login');
  };
  return (
    <Container>
      <CardContainer>
        <Card>
          <CardIcon><img src={ Rocket } alt="Rocket Icon" style={{ width: '50px' }}/></CardIcon>
          <CardTitle>For Startups</CardTitle>
          <CardList>
            <ListItem>Know your Fundability through holistic Score</ListItem>
            <ListItem>Match and Meet the Right investor</ListItem>
            <ListItem>Back your pitch with intelligence</ListItem>
          </CardList>
          <GetStartedButton onClick={handleInternalRedirect}>Get Started as Startup</GetStartedButton>
        </Card>

        <Card>
          <CardIcon><img src={ MoneyBall } alt="Money Ball Icon" style={{ width: '50px' }}/></CardIcon>
          <CardTitle>For Investors</CardTitle>
          <CardList>
            <ListItem>Let AI handle the L1 evaluation</ListItem>
            <ListItem>Match Ready Deals, No Cold Pitches</ListItem>
            <ListItem>Invest with clarity backed by data</ListItem>
          </CardList>
          <GetStartedButton onClick={signupRedirect}>Get Started as Investor</GetStartedButton>
        </Card>
      </CardContainer>
    </Container>
  );
};

const Container = styled.section`
  padding: 20px 20px;
  background-color: #fafafa;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 60px;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 20px;
    margin-bottom: 40px;
    padding: 0 16px;
    justify-content: flex-start;
  }

  @media (max-width: 480px) {
    margin-bottom: 30px;
  }
`;

const Card = styled.div`
  transition: transform 0.3s ease;
  /* background:linear-gradient(0deg, rgb(255, 255, 255), rgb(255 157 133 / 14%)); */
  background: #ffffff;
  box-shadow: 0 10px 10px rgba(162, 42, 1, 0.1);
  padding: 32px;
  border-radius: 16px;
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
  flex: 1;
  max-width: 500px;
  border: 0.5px solid rgba(255, 91, 36, 0.3);

  &:hover {
    border-color: #ff5924;
    box-shadow: 0 25px 60px rgba(255, 89, 36, 0.15);
    transform: translateY(-4px);
  }
`;

const CardIcon = styled.div`
  font-size: 40px;
  margin-bottom: 20px;
`;

const CardTitle = styled.h3`
  font-size: 32px;
  color: #333;
  margin-bottom: 20px;
  font-weight: bold;
  background: linear-gradient(90deg, #FF5733, #FF8C00);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const CardList = styled.ul`
  list-style: none;
  padding: 0;
`;

const ListItem = styled.li`
  margin-bottom: 12px;
  color: #666;
  font-size: 16px;
  display: flex;
  align-items: center;

  &:before {
    content: "•";
    color: #FF4B26;
    font-weight: bold;
    margin-right: 10px;
  }
`;

const GetStartedButton = styled.button`
  background: linear-gradient(90deg, #FF5733, #FF8C00);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  &:hover {
    background-color: #E63D1A;
  }
`;

export default UserTypeSection;
